<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Forgot Password</h1>
          <p>
            Enter your email address and we'll send you an link to reset your
            password.
          </p>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-centered">
                      <div class="column is-6-desktop">
                        <div class="control">
                          <BaseInput
                            v-model="email"
                            label="Email Address"
                            rules="required|email"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-text-centered">
                        <button
                          class="button is-primary btn-align no-lh raised has-margin-bottom-15"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          Submit</button
                        ><br />
                        <router-link :to="{ name: 'Login' }"
                          >Back to Login</router-link
                        >
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import AuthApi from '@/api/auth'
export default {
  name: 'ForgotPassword',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Forgot Password'
  },
  data() {
    return {
      loading: false,
      email: ''
    }
  },
  created() {},
  methods: {
    submit() {
      this.loading = true
      AuthApi.forgotPassword(this.email)
        .then(() => {
          this.$router.push({ name: 'Login', query: { registered: true } })
          this.$buefy.toast.open({
            message: "Check your inbox, we've send you a password reset link.",
            position: 'is-top',
            type: 'is-success'
          })
          this.loading = false
        })
        .catch(err => {
          let message = 'Error processing your request.'
          if (err && err.data && err.data.err === 'E_RESET_FAILED') {
            message = 'Error invalid email address.'
          }
          this.$buefy.toast.open({
            message: message,
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    }
  }
}
</script>
